export default __webpack_public_path__ + "static/media/Caret arrow icon - white.svg";